<div class="atendimento-fab" *ngIf="estreito && opcoes.length">
  <!-- fecha ao tocar fora: em celular, sair de um menu aberto precisa ser trivial. -->
  <div class="atendimento-fab__fundo" *ngIf="aberto" (click)="alternar()"></div>

  <div class="atendimento-fab__opcoes" *ngIf="aberto">
    <div class="atendimento-fab__opcao" *ngFor="let opcao of opcoes" (click)="ir(opcao)">
      <span class="atendimento-fab__rotulo">{{ opcao.rotulo }}</span>
      <button mat-mini-fab color="primary" type="button" [attr.aria-label]="opcao.rotulo">
        <mat-icon>{{ opcao.icone }}</mat-icon>
      </button>
    </div>
  </div>

  <button mat-fab color="accent" type="button" (click)="alternar()"
    [attr.aria-label]="aberto ? 'Fechar atalhos' : 'Atalhos de navegação'"
    [attr.aria-expanded]="aberto">
    <mat-icon>{{ aberto ? 'close' : 'apps' }}</mat-icon>
  </button>
</div>
